import InnerComponent from '@Components//Inventory/StockTransfer/StockTransferList';
import orgContainer from '@Components/AppContainer';

const StockTransferList = () => ((orgContainer(InnerComponent)));
export default StockTransferList;
